import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import { RequestProvider } from '../../../../context/RequestContext'
import { s3Static } from '../../../../utils/constants'
import { Services } from '../../service/Services'
import { openModal } from '../../../../service/modal-service'

export const PartTimeHelperRequestForm = (props) => {
    const requestCategorySettings = props.requestCategorySettings
    const requestType = "Domestic Services"
    
    const [ requestForm, setRequestForm ] = useState(false)

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        // setRequestForm(true)
        openModal(setRequestForm)
    }

    useEffect(() => {
        // setRequestForm(true)
        openModal(setRequestForm)
    }, [])

  return (
    <RequestProvider>
        <div id="part-time-cleaner-service" className="h-screen -mb-14 flex justify-center">
            <div className="h-full w-full absolute top-0">
                <Image className='bg-linear-to-br from-slate-800 to-orange-300'
                    src={s3Static + "part-time-helper/part-time-helper-posing.jpg"}
                    fill
                    style={{objectFit: 'cover', objectPosition: 'top'}}
                    alt='Part Time Helper Maid Singapore'
                    priority="false"
                    quality={100}
                    sizes="(max-width: 768px) 100vw, 33vw"
                />
            </div>        
            <div id="campaign" className='absolute top-1/2 -translate-y-1/2 w-full'>
                <div className='bg-black/30 rounded-lg w-fit mx-auto p-2 space-y-2 text-center text-white'> 
                    <div className='py-3'>
                        <button type="button" className='px-6 py-3 border border-white text-2xl rounded-lg font-bold' onClick={() => openRequestForm()}>
                            Book Now
                        </button>
                    </div>
                    <div className='text-lg'><strong>Part-time helper from $19/hr</strong></div>
                </div>  
            </div>
            <div className='fixed bottom-2 w-full text-center z-10 flex justify-center space-x-5'>
                <button type="button" className='text-white py-2 px-4 rounded-full bg-linear-to-tr from-amber-700 to-amber-400 block font-bold ' onClick={() => openRequestForm()}>
                    Book Now
                </button>
            </div> 
        </div>
        {requestForm &&
            <Services requestType={requestType} requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} asSheet/>
        }   
    </RequestProvider> 
  )
}
